import axiosInstance from '../AxiosInstance';

const SaaSBillingService = {
    plans: () => axiosInstance.get('/saas-billing/plans'),
    companies: () => axiosInstance.get('/saas-billing/companies'),
    permissions: () => axiosInstance.get('/saas-billing/permissions'),
    planPermissions: (planId) => axiosInstance.get(`/saas-billing/plans/${planId}/permissions`),
    modules: () => axiosInstance.get('/saas-billing/modules'),
    createModule: (payload) => axiosInstance.post('/saas-billing/modules', payload),
    createPermission: (payload) => axiosInstance.post('/saas-billing/permissions', payload),
    contracts: () => axiosInstance.get('/saas-billing/contracts'),
    // A grade dos webhooks pagina pelo ListPage (/saas-billing/webhooks/pageable); aqui ficam
    // os totais dos cards, com os mesmos filtros, e o detalhe com o payload bruto.
    webhookEventsSummary: (filters) => axiosInstance.post('/saas-billing/webhooks/summary', { filters }),
    webhookEvent: (id) => axiosInstance.get(`/saas-billing/webhooks/${id}`),
    currentPlanPermissions: () => axiosInstance.get('/saas-billing/access/permissions'),
    currentAccessStatus: () => axiosInstance.get('/saas-billing/access/status'),
    createPlan: (payload) => axiosInstance.post('/saas-billing/plans', payload),
    updatePlan: (payload) => axiosInstance.post('/saas-billing/plans/update', payload),
    updatePlanPermissions: (payload) => axiosInstance.post('/saas-billing/plans/permissions', payload),
    // Liga o link exclusivo do plano (se ele não estiver no site) e devolve o plano com o uuid do link.
    enablePlanSignupLink: (planId) => axiosInstance.post(`/saas-billing/plans/${planId}/signup-link`),
    createContract: (payload) => axiosInstance.post('/saas-billing/contracts', payload),
    updateContract: (payload) => axiosInstance.post('/saas-billing/contracts/update', payload),
    // Prévia da troca de plano: valores do plano atual e do novo, se é upgrade ou
    // downgrade, e qual fatura em aberto seria afetada. Não altera nada.
    planChangePreview: (payload) => axiosInstance.post('/saas-billing/contracts/plan-change-preview', payload),
    cancelContract: (payload) => axiosInstance.post('/saas-billing/contracts/cancel', payload),
    exemptContract: (payload) => axiosInstance.post('/saas-billing/contracts/exempt', payload),
    revokeExemption: (payload) => axiosInstance.post('/saas-billing/contracts/exempt/revoke', payload),
};

export default SaaSBillingService;
